import _find from "lodash/find";
import React from "react";
import { Translate } from "react-localize-redux";
import PropTypes from "prop-types";
import {
  getAddressField,
  getContactNumber,
  getFullName,
} from "../../utils/profilePrivacy";
import "./styles.scss";

class BasicSearchRow extends React.Component {
  isContact(itemId) {
    if (this.props.contacts) {
      return _find(this.props.contacts, contact => contact.id === itemId);
    }
    return false;
  }

  render() {
    const {
      rowItem,
      onAdd,
      onRemove,
      isUserLoggedIn,
      onRowClick,
      loggedInUser,
      showContactAction
    } = this.props;
    return (
      <tr className="table-row">
        <td onClick={onRowClick}>{getFullName(rowItem, loggedInUser)}</td>
        <td onClick={onRowClick}>
          {getAddressField(rowItem, loggedInUser, "city_district")}
        </td>
        <td onClick={onRowClick}>{getContactNumber(rowItem, loggedInUser)}</td>
        {showContactAction && (
          <td>
            {!this.isContact(rowItem.id) ? (
              <a
                className="btn search-table-btn grey-btn"
                onClick={() => onAdd(rowItem.id)}
              >
                <Translate id="addText" />
              </a>
            ) : (
              <a
                className="btn search-table-btn grey-btn"
                onClick={() => onRemove(this.isContact(rowItem.id).id)}
              >
                <Translate id="removeText" />
              </a>
            )}
          </td>
        )}
      </tr>
    );
  }
}

BasicSearchRow.propTypes = {
  contacts: PropTypes.array,
  onAdd: PropTypes.func,
  onRemove: PropTypes.func,
  rowItem: PropTypes.object,
  loggedInUser: PropTypes.object,
  isUserLoggedIn: PropTypes.bool
};

export default BasicSearchRow;



// WEBPACK FOOTER //
// ./src/components/BasicSearchRow/BasicSearchRow.jsx